var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgReferralIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "#FCFAFF",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.5 25H4.5C3.83696 25 3.20107 24.7366 2.73223 24.2678C2.26339 23.7989 2 23.163 2 22.5V7.39125C2.02804 6.74724 2.30376 6.13895 2.7696 5.69338C3.23543 5.2478 3.85538 4.99939 4.5 5H24.5C25.163 5 25.7989 5.26339 26.2678 5.73223C26.7366 6.20107 27 6.83696 27 7.5V22.5C27 23.163 26.7366 23.7989 26.2678 24.2678C25.7989 24.7366 25.163 25 24.5 25ZM4.5 9.835V22.5H24.5V9.835L14.5 16.5L4.5 9.835ZM5.5 7.5L14.5 13.5L23.5 7.5H5.5Z",
    stroke: "none"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReferralIcon);
export default __webpack_public_path__ + "static/media/referral-icon.f2ae486acdb3b9fb771704f77d8d6bcb.svg";
export { ForwardRef as ReactComponent };